import React, { memo, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { FeedbackMessage } from 'components/marketplace/FeedbackMessage'
import PropTypes from 'prop-types'
import { Card } from 'transfix-ui/components/Card'
import { Spinner } from 'transfix-ui/components/Spinner'
import { stopsSummary } from 'utils/shipmentHelpers'

export const RecentShipment = memo(({ last, shipment }) => {
  const { id, status } = shipment || {}
  const { name } = status || {}
  const { delivery, pickup } = stopsSummary(shipment)
  return (
    <>
      <div>{name}</div>
      <div>
        <a
          className='mr1'
          href={`${__ROOT__}/shipment-details/${id}?tab=scheduling`}
          target='_blank'
          rel='noopener noreferrer'>
          {id}
        </a>
        <strong>
          {pickup.city}, {pickup.state} &ndash; {delivery.city}, {delivery.state}
        </strong>
      </div>
      <div>
        {pickup.date} {pickup.timeTZ} &ndash; {delivery.date} {delivery.timeTZ}
      </div>
      {!last && <hr data-test='shipments-separator' />}
    </>
  )
})

const shipmentPropType = PropTypes.shape({
  id: PropTypes.number,
  status: PropTypes.shape({
    name: PropTypes.string,
  }),
})

RecentShipment.propTypes = {
  shipment: shipmentPropType.isRequired,
  last: PropTypes.bool,
}
RecentShipment.defaultProps = {
  last: false,
}

export const RecentShipments = memo(
  ({ dataLoadedForUserId, error, fetching, getShipments, shipments, userId }) => {
    const ready = !fetching && !error

    const getUserFilter = id => ({ parentUserId: id, usersType: 'parent_user' })

    useEffect(() => {
      if (userId && dataLoadedForUserId !== userId) {
        getShipments({
          filters: getUserFilter(userId),
          sortField: 'pickups',
          sortOrder: 'desc',
          perPage: 10,
        })
      }
    }, [userId])

    return (
      <Card title='Recent Shipments'>
        {fetching && <Spinner />}
        {error && <FeedbackMessage message={error} type='error' />}
        {ready && (
          <div>
            <div className='mb2'>
              {shipments.map((shipment, i) => (
                <RecentShipment
                  key={shipment.id}
                  shipment={shipment}
                  last={i === shipments.length - 1}
                />
              ))}
            </div>
            <p>
              <Link to={`/${userId}/shipments`}>View all shipments</Link>
            </p>
          </div>
        )}
      </Card>
    )
  }
)

RecentShipments.propTypes = {
  userId: PropTypes.number,
  dataLoadedForUserId: PropTypes.number,
  getShipments: PropTypes.func,
  fetching: PropTypes.bool,
  error: PropTypes.string,
  shipments: PropTypes.arrayOf(shipmentPropType),
}

RecentShipments.defaultProps = {
  userId: null,
  dataLoadedForUserId: null,
  getShipments: () => {},
  fetching: null,
  error: null,
  shipments: [],
}
